import { procesar } from './cola';

/**
 * Registra el service worker y engancha Background Sync donde exista.
 *
 * Todo aquí es best-effort a propósito: si el navegador no soporta service
 * workers o Background Sync (iOS, por ejemplo), la app sigue funcionando igual.
 * El vaciado de la cola no depende de esto — lo disparan los eventos `online` y
 * `visibilitychange` de cola.ts, que sí existen en todas partes.
 */
export function registrarServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(async (registro) => {
        // Si el navegador lo soporta, que el sistema nos despierte cuando
        // vuelva la red aunque la app esté en segundo plano.
        const conSync = registro as ServiceWorkerRegistration & {
          sync?: { register(tag: string): Promise<void> };
        };
        try {
          await conSync.sync?.register('vaciar-cola');
        } catch {
          // Sin Background Sync no pasa nada: quedan los otros disparadores.
        }
      })
      .catch(() => {
        // Un fallo al registrar no debe impedir usar la app.
      });

    navigator.serviceWorker.addEventListener('message', (evento) => {
      if ((evento.data as { tipo?: string })?.tipo === 'vaciar-cola') {
        void procesar();
      }
    });
  });
}
